export const translations = {
    'PTBR': {
        curiosities: 'Curiosidades sobre o tópico',
        tips: 'Dicas',
        loading: 'Carregando',
        continue: 'Continuar',
    },
    'EN': {
        curiosities: 'Curiosities about the topic',
        tips: 'Tips',
        loading: 'Loading',
        continue: 'Continue',
    },
    'ES': {
        curiosities: 'Curiosidades sobre el tema',
        tips: 'Consejos',
        loading: 'Cargando',
        continue: 'Continuar',
    },
    'FR': {
        curiosities: 'Curiosités sur le sujet',
        tips: 'Conseils',
        loading: 'Chargement',
        continue: 'Continuer',
    },
    'DE': {
        curiosities: 'Kuriositäten zum Thema',
        tips: 'Tipps',
        loading: 'Wird geladen',
        continue: 'Fortsetzen',
    },
    'IT': {
        curiosities: 'Curiosità sul tema',
        tips: 'Suggerimenti',
        loading: 'Caricamento',
        continue: 'Continua',
    }
}

export type LanguageKeys = keyof typeof translations;